class CryoShowerMegaMenu {
  constructor(root) {
    if (!root) return;

    this.root = root;
    this.triggerHandle = root.dataset.triggerHandle || 'shop';
    this.triggerTitle = root.dataset.triggerTitle || 'Shop';
    this.desktopPanel = root.querySelector('[data-cryoshower-mega-desktop]');
    this.mobilePanel = root.querySelector('[data-cryoshower-mega-mobile]');
    this.backdrop = root.querySelector('[data-cryoshower-mega-backdrop]');
    this.isOpen = false;
    this.isMobile = window.innerWidth < 1024;
    this.triggerItems = { desktop: null, mobile: null };
    this.openTimer = null;
    this.closeTimer = null;
    this.openDelay = 60;
    this.closeDelay = 280;

    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.close = this.close.bind(this);

    this.init();
  }

  init() {
    this.portalToBody();
    this.findTriggers();
    this.bindDesktop();
    this.bindMobile();
    this.bindPanelControls();

    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        this.portalToBody();
        this.findTriggers();
        this.bindDesktop();
        this.bindMobile();
      });
    }

    if (!this.triggerItems.desktop) {
      window.setTimeout(() => {
        this.findTriggers();
        this.bindDesktop();
        this.bindMobile();
      }, 500);
    }
  }

  portalToBody() {
    if (!this.root || this.root.dataset.portaled === 'true') return;
    document.body.appendChild(this.root);
    this.root.dataset.portaled = 'true';
    this.root.classList.add('is-portaled');
  }

  getLinkLabel(link) {
    if (!link) return '';
    const clone = link.cloneNode(true);
    clone.querySelectorAll('.m-menu__arrow, svg, .m-menu__sub-arrow').forEach((el) => el.remove());
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  handleize(text) {
    return (text || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  findTriggers() {
    this.triggerItems.desktop = null;
    this.triggerItems.mobile = null;

    document.querySelectorAll('.m-menu__item').forEach((item) => {
      const link = item.querySelector(':scope > a.m-menu__link--main, :scope > a.m-menu__link');
      if (!link) return;
      const label = this.getLinkLabel(link);
      if (this.handleize(label) !== this.triggerHandle) return;

      this.triggerItems.desktop = item;
      item.classList.add('cryoshower-mega__trigger-item');
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', this.desktopPanel ? this.desktopPanel.id : '');

      const themeMega = item.querySelector('.m-mega-menu');
      if (themeMega) themeMega.setAttribute('hidden', 'hidden');

      item.classList.remove('m-menu__item--mega', 'm-menu__item--has-submenu');
    });

    document.querySelectorAll('.m-menu-mobile__item').forEach((item) => {
      const link = item.querySelector(':scope > a.m-menu-mobile__link');
      if (!link) return;
      const label = this.getLinkLabel(link);
      if (this.handleize(label) !== this.triggerHandle) return;

      this.triggerItems.mobile = item;
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');

      const themeSubmenu = item.querySelector('.m-megamenu-mobile');
      if (themeSubmenu) themeSubmenu.setAttribute('hidden', 'hidden');

      const toggle = item.querySelector('.m-menu-mobile__toggle-button');
      if (toggle) toggle.setAttribute('hidden', 'hidden');
    });
  }

  isPointerInsideDesktop() {
    const item = this.triggerItems.desktop;
    if (!item || !this.desktopPanel) return false;
    return item.matches(':hover') || this.desktopPanel.matches(':hover');
  }

  clearOpenTimer() {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
  }

  clearCloseTimer() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  scheduleOpen() {
    if (this.isMobile) return;
    this.clearCloseTimer();

    if (this.isOpen) return;

    this.clearOpenTimer();
    this.openTimer = setTimeout(() => {
      if (this.isPointerInsideDesktop()) {
        this.open('desktop');
      }
    }, this.openDelay);
  }

  scheduleClose() {
    if (this.isMobile) return;
    this.clearOpenTimer();

    this.clearCloseTimer();
    this.closeTimer = setTimeout(() => {
      if (!this.isPointerInsideDesktop()) {
        this.close();
      }
    }, this.closeDelay);
  }

  bindDesktopHoverTarget(target) {
    if (!target || target.dataset.cryoshowerHoverBound === 'true') return;
    target.dataset.cryoshowerHoverBound = 'true';

    target.addEventListener('mouseenter', () => this.scheduleOpen());
    target.addEventListener('mouseleave', () => this.scheduleClose());
    target.addEventListener('focusin', () => this.scheduleOpen());
    target.addEventListener('focusout', (e) => {
      const item = this.triggerItems.desktop;
      if (item && item.contains(e.relatedTarget)) return;
      if (this.desktopPanel && this.desktopPanel.contains(e.relatedTarget)) return;
      this.scheduleClose();
    });
  }

  bindDesktop() {
    const item = this.triggerItems.desktop;
    if (!item || !this.desktopPanel || item.dataset.cryoshowerBound === 'true') return;
    item.dataset.cryoshowerBound = 'true';

    const link = item.querySelector(':scope > a.m-menu__link--main, :scope > a.m-menu__link');

    this.bindDesktopHoverTarget(item);
    this.bindDesktopHoverTarget(this.desktopPanel);


    link.addEventListener('click', () => {
  if (this.isMobile) return;
  this.clearOpenTimer();
  this.close();
});

    // link.addEventListener('click', (e) => {
    //   if (this.isMobile) return;
    //   if (this.isOpen) {
    //     e.preventDefault();
    //     this.close();
    //   }
    // });
  }

  bindMobile() {
    const item = this.triggerItems.mobile;
    if (!item || item.dataset.cryoshowerBound === 'true') return;
    item.dataset.cryoshowerBound = 'true';

    const link = item.querySelector(':scope > a.m-menu-mobile__link');
    const openMobile = (e) => {
      if (!this.isMobile) return;
      e.preventDefault();
      this.open('mobile');
    };

    link.addEventListener('click', openMobile);

    const oldToggle = item.querySelector('.m-menu-mobile__toggle-button');
    if (oldToggle) {
      oldToggle.addEventListener('click', openMobile);
    }
  }

  bindPanelControls() {
    this.root.querySelectorAll('[data-cryoshower-mega-back], [data-cryoshower-mega-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });
  }

  onDocumentClick(e) {
    if (!this.isOpen || this.isMobile) return;

    const item = this.triggerItems.desktop;
    if (item && item.contains(e.target)) return;
    if (this.desktopPanel && this.desktopPanel.contains(e.target)) return;

    this.close();
  }

  open(mode) {
    if (this.isOpen && this.root.classList.contains(`is-open--${mode}`)) return;

    this.clearOpenTimer();
    this.clearCloseTimer();
    this.isOpen = true;

    this.root.classList.add('is-open');
    this.root.classList.toggle('is-open--desktop', mode === 'desktop');
    this.root.classList.toggle('is-open--mobile', mode === 'mobile');

    if (this.desktopPanel && mode === 'desktop') {
      this.positionDesktopPanel();
      requestAnimationFrame(() => {
        this.desktopPanel.classList.add('is-visible');
        this.desktopPanel.setAttribute('aria-hidden', 'false');
      });
      this.triggerItems.desktop?.classList.add('cryoshower-mega__trigger-item--active');
    }

    if (this.mobilePanel && mode === 'mobile') {
      this.mobilePanel.classList.add('is-visible');
      this.mobilePanel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('prevent-scroll');
    }

    this.setExpanded(true);
  }

  close() {
    if (!this.isOpen) return;

    this.clearOpenTimer();
    this.clearCloseTimer();
    this.isOpen = false;

    this.root.classList.remove('is-open', 'is-open--desktop', 'is-open--mobile');

    if (this.desktopPanel) {
      this.desktopPanel.classList.remove('is-visible');
      this.desktopPanel.setAttribute('aria-hidden', 'true');
    }

    if (this.mobilePanel) {
      this.mobilePanel.classList.remove('is-visible');
      this.mobilePanel.setAttribute('aria-hidden', 'true');
    }

    this.triggerItems.desktop?.classList.remove('cryoshower-mega__trigger-item--active');
    document.documentElement.classList.remove('prevent-scroll');
    this.setExpanded(false);
  }

  positionDesktopPanel() {
    if (!this.desktopPanel) return;

    const headerDesktop = document.querySelector('header.m-header__desktop');
    const topbar = document.querySelector('.m-topbar');
    const announcement = document.querySelector('m-announcement-bar');

    let top = 0;
    if (announcement) top = Math.max(top, announcement.getBoundingClientRect().bottom);
    if (topbar && topbar.offsetParent !== null) top = Math.max(top, topbar.getBoundingClientRect().bottom);
    if (headerDesktop && headerDesktop.offsetParent !== null) {
      top = Math.max(top, headerDesktop.getBoundingClientRect().bottom);
    }

    top = Math.max(top, 0);
    this.desktopPanel.style.top = `${top}px`;
    document.documentElement.style.setProperty('--cryoshower-mega-top', `${top}px`);
  }

  onScroll() {
    if (this.isOpen && !this.isMobile) this.positionDesktopPanel();
  }

  setExpanded(expanded) {
    [this.triggerItems.desktop, this.triggerItems.mobile].forEach((item) => {
      if (!item) return;
      const link = item.querySelector('a');
      if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  onResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 1024;
    if (wasMobile !== this.isMobile) this.close();
    if (this.isOpen && !this.isMobile) this.positionDesktopPanel();
  }

  onKeydown(e) {
    if (e.key === 'Escape' && this.isOpen) this.close();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('cryoshower-mega-root');
  if (root) window.cryoShowerMegaMenu = new CryoShowerMegaMenu(root);
});

if (document.readyState !== 'loading') {
  const root = document.getElementById('cryoshower-mega-root');
  if (root && !window.cryoShowerMegaMenu) {
    window.cryoShowerMegaMenu = new CryoShowerMegaMenu(root);
  }
}
